module.exports = __webpack_public_path__ + "static/yotta-splash-screen-77f52799398f70a163f4b74a3a9f94e7.mp4";